// extracted by mini-css-extract-plugin
export default {"copy":"Footer_copy__r2-PV"};